import { type IDistinctPatientMappingItem } from 'features/Profile/features/Prescriptions/patient-data.api'
import { MapPatientManuallyModal } from './MapPatientManually'

export const DistinctPatientsTableColumns = [
  {
    title: 'Action',
    dataIndex: 'action',
    key: 'action',
    width: 100,
    render: (_: string, item: IDistinctPatientMappingItem) => {
      return <MapPatientManuallyModal item={item} />
    },
  },
  {
    title: 'First Name',
    dataIndex: 'first_name',
    key: 'first_name',
    type: 'text',
    className: 'table-col-min-width-md',
    editable: false,
    sorter: true,
  },
  {
    title: 'Last Name',
    dataIndex: 'last_name',
    key: 'last_name',
    type: 'text',
    className: 'table-col-min-width-md',
    editable: false,
    sorter: true,
  },
  {
    title: 'Pharmacy Name',
    dataIndex: 'pharmacy_name',
    key: 'pharmacy_name',
    type: 'text',
    className: 'table-col-min-width-md',
    editable: false,
    sorter: true,
  },
  {
    title: 'Pharmacy Phone Number',
    dataIndex: 'pharmacy_phone_number',
    key: 'pat_phone',
    type: 'text',
    editable: false,
    sorter: true,
  },
]
